import { v4 as uuidv4 } from "uuid";

const STORAGE_KEY = "user_uuid";

// We now send user_uuid in payloas instead of in cookie to bypass cross-domain
// as it serve the same purpose
export const getOrCreateUserUUID = () => {
    let uuid = localStorage.getItem(STORAGE_KEY);

    if (!uuid) {
        uuid = uuidv4();
        localStorage.setItem(STORAGE_KEY, uuid);
    }

    return uuid;
};